import { Box, Breadcrumbs, capitalize, useTheme } from "@mui/material";
import { Link, useLocation } from "react-router-dom";

const Breadcrumb = () => {
  const theme = useTheme();
  let location = useLocation();
  const pathName = location.pathname;
  let paths = pathName.split("/");
  const length = paths.length - 3;

  return (
    <Box mt={-1.5} mb={2}>
      <Breadcrumbs separator=">" aria-label="breadcrumb">
        <Link
          style={{
            cursor: "pointer",
            color: "#000",
          }}
          to="/admin/dashboard"
        >
          Dashboard
        </Link>

        {paths.slice(2).map((el, index) => {
          const current = paths.findIndex((path) => path === el);
          return (
            <Link
              style={{
                cursor: "pointer",
                color:
                  length === index
                    ? "grey"
                    : theme.palette.type === "dark"
                    ? "#fff"
                    : "#000",
              }}
              key={index}
              to={paths.slice(0, current + 1).join("/")}
            >
              {capitalize(el)}
            </Link>
          );
        })}
      </Breadcrumbs>
    </Box>
  );
};

export default Breadcrumb;
